import React from 'react';
import PropTypes from 'prop-types';

import styles from './Toggle.scss';

export default function Toggle({isActive, onChange}) {

	return (
		<div className={`${styles.toggle} ${isActive === true ? styles.on : styles.off}`}
			 onClick={onChange}>
			<span>
				{
					isActive === true ? 'ON' : 'OFF'
				}
			</span>
			<span className={styles.editCircle}/>
		</div>
	)
}
Toggle.propTypes = {
	isActive: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
}